import { FC } from 'react'
import styles from 'components/features/pfm/CategoryBreakdown/Bar.styl'
import { getBarLength } from 'helpers/categoriesHelpers'
import cn from 'classnames'

type BarProps = {
  amount: number
  max: number
  className?: string
}

export const Bar: FC<BarProps> = (props) => {
  const { amount, max, className } = props
  const width = getBarLength(amount, max)

  return (
    <div className={ cn(styles.bar, className) } style={{ width: `${ width }%` }} />
  )
}
